import React, { useMemo, useState } from 'react';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Add, Assignment, PictureAsPdf, Restore, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import { Box, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { wsFindBy, wsUrl } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ButtonDelete from 'hooks/ButtonDelete';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import Badge from 'components/Badge/Badge';
import { wsUpdate } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import moment from 'moment';
import { currency } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '1.5em',
    display: 'flex',
    alignItems: 'baseline',
  },
  totals: {
    fontSize: '16px',
    // '& .': {
    marginLeft: '20px',
    fontWeight: 'bold',
    color: 'black',
    // },
  },
  loader: {
    marginLeft: '20px',
  },
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 250 },
  { Header: 'ID', accessor: 'id', width: 100 },
  // { Header: 'Fec. Cont.', accessor: 'TaxDate', width: 100 },
  { Header: 'Fec. Doc.', accessor: 'DocDate', width: 100 },
  { Header: 'Monto', accessor: 'DetailAmount', width: 120 },
  // { Header: 'Guía', accessor: 'guide', width: 150 },
  { Header: 'Del almacén', accessor: 'FillerWhsName' },
  { Header: 'Al almacén', accessor: 'ToWhsName' },
  // { Header: 'Cuenta', accessor: 'WhsAcctCode', width: 100 },
  // { Header: 'Título', accessor: 'JrnlMemo' },
  // { Header: 'Estado', accessor: 'state_migrate', width: 110 },
  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Validado por', accessor: 'validated_user_name' },
  { Header: 'Aprobado por', accessor: 'approved_user_name' },
  { Header: 'Comentario', accessor: 'Comments' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function KardexSharedFile(props) {
  const classes = useStyles();

  const { title, entity, type, excelName, permissions } = props;

  const [kardexs, setKardexs] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [openPDF, setOpenPDF] = useState(false);
  const [urlPDF, setURLPDF] = useState('');
  const [processing, setProcessing] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  let warehouseType = [];
  let transferDM ='';
  if (type == 'DTR') {
    warehouseType = ["M","D"];
    transferDM = 'D';
  } else if (type == 'MTR') {
    warehouseType = ["M","M"];
    transferDM = 'M';
  }

  async function listKardex(search) {
    setDataLoading(true);
    setValueSearch(search);
    const typeInventory = "N";

    const params = {
      ...search,
      TypeInventory: typeInventory,
      transferReturns: transferDM,
    };
    let response = await wsFindBy(entity, params);
    setDataLoading(false);
    if (response.success) setKardexs(response.data);
  }

  function getUrlPDF(idItem) {
    setDataLoading(true);
    let urlPdfHR = wsUrl(`${entity}/${idItem}/report`);
    setURLPDF(urlPdfHR);
    setOpenPDF(true);
    setDataLoading(false);
  }

  async function restoreError(item) {
    setDataLoading(true);
    setProcessing(true);
    let res = await wsUpdate(`${entity}/${item.id}/remove-error`);
    setProcessing(false);
    setDataLoading(false);
    if (res.success) {
      listKardex(valueSearch);
    }
    window.alert(res.message);
  }

  const totalComision = useMemo(() => {
    return kardexs.reduce(
      (acc, transfer) => acc + parseFloat(transfer.DetailAmount || 0),
      0
    ).toFixed(2);
  }, [kardexs]);

  return (
    <>
      <ModalFull
        title="Hoja reparto"
        open={openPDF}
        setOpen={() => {
          setOpenPDF(!openPDF);
        }}
        iframe
      >
        <iframe src={openPDF ? urlPDF : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
        </iframe>
      </ModalFull>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>

          <div className={classes.cardIconTitle}>
              {/* <h4 className={classes.cardIconTitle}> */}
                Listado de {title}
              {/* </h4> */}
            <div className={classes.totals}>
              <span className={classes.totals}>Total Comisión: {currency(totalComision)}</span>
            </div>
            <div className={classes.loader}>
              {dataLoading && <LoadingSpinner />}
            </div>
          </div>

        </CardHeader>
        <CardBody>
          <FilterCustom
            dateRange
            getFilter={listKardex}
            state
            nameState="state_migrate"
            zone
            warehouse={warehouseType}
            optionValues={['D', 'V', 'X', 'P']}
            nameOptions={['Borrador', 'Validado', 'Procesando', 'Completo']}
          />

          <ReactTable
            excelName={excelName}
            formatDate="DD-MM-YYYY"
            columns={columns}
            colorRow={(item) => {
              const hoy = moment();
              const docDate = moment(item.DocDate, 'DD-MM-YYYY');
              const diffDays = hoy.diff(docDate, 'days');

              if (diffDays <= 30) return '#43ff6b61';
              if (diffDays > 30 && diffDays <= 60) return '#ffee0073';
              if (diffDays > 60) return '#ff000073';
              return '';
            }}
            data={kardexs.map((item, i) => {
              let state;
              let stateColor = '';
              let hasError = false;
              switch (item.state_migrate) {
                case 'D':
                  stateColor = 'warning';
                  state = 'Borrador';
                  break;
                case 'V':
                  stateColor = 'primary';
                  state = 'Validado';
                  break;
                case 'X':
                  stateColor = 'info';
                  state = 'Procesando';
                  break;
                case 'P':
                  stateColor = 'success';
                  state = 'Completo';
                  break;
                default:
                  stateColor = 'gray';
                  state = 'Otros';
                  break;
              }
              if (item.state_migrate === 'X' && item.sapCount >= 3) {
                hasError = true;
              }
              let guide = null;
              if (!!item.GuideSerie) {
                guide = `${item.GuideSerie}-${item.GuideNumber.padStart(8, '0')}`;
              }
              return {
                num: (
                  <Box display="flex" alignItems="center">
                    {i + 1}
                    <AllowedGuard permission={permissions.show}>
                      <Button justIcon round simple>
                        <Link to={`${item.id}?type=${type}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>

                    <AllowedGuard permission={permissions.show}>
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        onClick={() => getUrlPDF(item.id)}
                        disabled={item.DocEntry === null}
                      >
                        <PictureAsPdf />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={permissions.delete}>
                      <ButtonDelete
                        disabled={['P'].includes(item.state_migrate)}
                        entity={entity}
                        id={item.id}
                        reload={() => listKardex(valueSearch)}
                      />
                    </AllowedGuard>

                    {hasError ? (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Tooltip title={item.sapError}>
                          <div>
                            <Badge color="danger">Error!</Badge>
                          </div>
                        </Tooltip>
                        <Button
                          size="sm"
                          color="danger"
                          disabled={processing}
                          justIcon
                          simple
                          round
                          onClick={() => restoreError(item)}
                        >
                          <Restore />
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Badge color={stateColor}>{state}</Badge>
                      </div>
                    )}
                  </Box>
                ),
                id: item.id.toString(),
                TaxDate: item.TaxDate,
                DocDate: item.DocDate,
                guide: guide || 'No generado',
                DetailAmount:
                  item.DetailAmount === null
                    ? '-'
                    : `S/${parseFloat(item.DetailAmount).toFixed(2)}`,
                providers: item.providers || "-",
                marks: item.marks || "-",
                Ref2: item.Ref2,
                WhsName: item.WhsName,
                FillerWhsName: item.FillerWhsName,
                ToWhsName: item.ToWhsName,
                WhsAcctCode: item.WhsAcctCode,
                JrnlMemo: item.JrnlMemo,
                state_migrate: state,
                user_validated: item.user_validated,
                created_user_name: item.created_user_name,
                validated_user_name: item.validated_user_name,
                approved_user_name: item.approved_user_name,
                Comments: item.Comments,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
